import React from 'react';
import EventSource from '../EventSource.js';

class Growler {
  constructor() {
    this._callbacks = [];
    this._eventSource = new EventSource();
    this._lastId = 0;
  }

  onGrowl(callback) {
    return this._eventSource.subscribe(callback);
  }
  
  growlMultiple(growls) {
    let publishableGrowls = growls.map(growl => {
      this._lastId++;
      return {
        id: this._lastId,
        context: growl.context,
        message: growl.message,
        type: growl.type || 'success',
        action: growl.action,
        suppressOpenAnimation: growl.suppressOpenAnimation,
        onClose: growl.onClose,
        onDismiss: growl.onDismiss,
        closeScheduled: growl.closeScheduled,
      };
    });
    
    this._eventSource.publish(publishableGrowls);
  }

  growl(growl) {
    if (typeof growl === 'string' || React.isValidElement(growl)) {
      growl = {
        message: growl,
      };
    }

    this._lastId++;
    this._eventSource.publish({
      id: this._lastId,
      context: growl.context,
      message: growl.message,
      type: growl.type || 'success',
      action: growl.action,
      suppressOpenAnimation: growl.suppressOpenAnimation,
      onClose: growl.onClose,
      onDismiss: growl.onDismiss,
      closeScheduled: growl.closeScheduled,
    });

    return this._lastId;
  }
}

let instance = new Growler();

export {
  Growler as default,
  instance
};